import { ChangeEvent } from "react";
import { faUndo } from "@fortawesome/free-solid-svg-icons/faUndo";
import { resources } from "@constants/hardcoded-strings";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { AXNUIContent, AXNUIContentConfirmButton } from "@iddataweb/idw-common-ui/types";
import { ThemingActionButtonValidationErrors } from "@idw-types/common/validation/common/theming-validation-errors";
import { InputFormGroup } from "../../../../../common/input-form-group/input-form-group";
import commonStyles from "../../../verification-service-details-component.less";
import { ThemingFormGroupWrapper } from "@containers/common/theming-input-form-group/theming-form-group-wrapper";
import { PageLevelTypes } from "@enums/page-level-types";

type ThemingActionButtonAsyncSectionProps = {
    layout: LayoutTypes;
    labelWidth: LabelWidthTypes;
    isDisabled: boolean;
    axnuiContent: AXNUIContent;
    inheritedAXNUIContent: AXNUIContent;
    pageLevel: PageLevelTypes;
    validationErrors: ThemingActionButtonValidationErrors;
    updateAXNUIContentConfirmButtonFieldValue: (key: keyof AXNUIContentConfirmButton, value: string) => void;
};

export const ThemingActionButtonAsyncSection = (props: ThemingActionButtonAsyncSectionProps) => {
    const {
        layout,
        labelWidth,
        isDisabled,
        axnuiContent,
        inheritedAXNUIContent,
        pageLevel,
        validationErrors,
        updateAXNUIContentConfirmButtonFieldValue
    } = props;

    const handleAsyncButtonTextChange = async (event: ChangeEvent<HTMLInputElement>) => {
        updateAXNUIContentConfirmButtonFieldValue("asyncButtonText", event.target.value);
    };

    const handleResetAsyncButtonText = () => {
        updateAXNUIContentConfirmButtonFieldValue("asyncButtonText", inheritedAXNUIContent.confirmButton.asyncButtonText);
    };

    return (
        <div>
            <span className={commonStyles.description}>{resources.pages.verificationServiceDetails.tabs.theming.subTabs.actionButton.asyncMessage}</span>
            <ThemingFormGroupWrapper
                inheritedThemingPropertyValue={inheritedAXNUIContent.confirmButton.asyncButtonText}
                currentThemingPropertyValue={axnuiContent.confirmButton.asyncButtonText}
                pageLevel={pageLevel}
            >
                <InputFormGroup
                    controlId={"theming-action-button-async-button-text-input"}
                    automationId={"theming-action-button-async-button-text-input"}
                    label={resources.pages.verificationServiceDetails.tabs.theming.subTabs.actionButton.inputs.asyncButtonText.label}
                    ariaLabel={resources.pages.verificationServiceDetails.tabs.theming.subTabs.actionButton.inputs.asyncButtonText.label}
                    layout={layout}
                    labelWidth={labelWidth}
                    onChange={handleAsyncButtonTextChange}
                    value={axnuiContent.confirmButton.asyncButtonText || ""}
                    disabled={isDisabled}
                    isRequired={true}
                    afterLabelTooltipText={resources.pages.verificationServiceDetails.tabs.theming.subTabs.actionButton.inputs.asyncButtonText.tooltip}
                    afterLabelIcon={isDisabled ? null : faUndo}
                    afterLabelIconOnClick={handleResetAsyncButtonText}
                />
            </ThemingFormGroupWrapper>
            {validationErrors.continueOnMobileTextError}
        </div>
    );
};